module.exports = __webpack_public_path__ + "01ea978f/img/pwrd-by-sourcery-black.bba9ba41.svg";